export default {"src":"/_next/static/media/for-businesses.893b8b11.svg","height":17,"width":20,"blurWidth":0,"blurHeight":0};